import { render } from "./CheckoutPayment.vue?vue&type=template&id=4bb204c9"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js"

import "./CheckoutPayment.vue?vue&type=style&index=0&id=4bb204c9&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__